import { atom } from "nanostores";

export const currencyCode = atom("DMO");
export const language = atom("en");
export const currentBetCredit = atom(0);
